import { useState, useEffect, useMemo } from 'react';
import { getARByDates } from '../../helper/helper';
import { filterAccessoryARData } from './utils';

const AccessoryAR = ({ incomingDate, currentFilter }) => {
  const userDetails = useMemo(() => JSON.parse(localStorage.getItem('user_data')), []);
  const [attachRateData, setAttachRateData] = useState(null);

  useEffect(() => {
    const fetchAttachRateData = async () => {
      try {
        const { data } = await getARByDates({
          startDate: incomingDate.startDate,
          endDate: incomingDate.endDate,
          username: userDetails.username,
          //   employeName: data.employeName,
          //   storeName: data.storeName,
        });
        setAttachRateData(data);
      } catch (err) {}
    };
    if (userDetails?.username && incomingDate?.startDate && incomingDate?.endDate) {
      fetchAttachRateData();
    }
  }, [incomingDate, userDetails?.username]);

  let selectedARData = filterAccessoryARData(attachRateData, currentFilter);

  return (
    <div className="top-div-bot1">
      <div className="top-div-title">
        <p>Accessories AR</p>
      </div>
      <div className="top-div-body">
        <div className="target">
          <p>
            {!selectedARData.Total_ACT && selectedARData.hupARate
              ? 'Total-HUP'
              : !selectedARData.hupARate && selectedARData.Total_ACT
              ? 'Total-ACT'
              : 'Total'}
          </p>
          <span>{(selectedARData?.Total_ACT || 0).toFixed(2)}%</span>
        </div>
        <div className="target">
          <p>Activations</p>
          <span>{(selectedARData?.actARate || 0).toFixed(2)}%</span>
        </div>
        <div className="target">
          <p>HUP</p>
          <span>{(selectedARData?.hupARate || 0).toFixed(2)}%</span>
        </div>
      </div>
    </div>
  );
};

export default AccessoryAR;
